import React from 'react'
import styled from '@emotion/styled'
import { components, type OptionProps } from 'react-select'
import { CheckboxBase } from '@instacart/ids-core'
import { colors, fontWeight, fontSize } from '@retailer-platform/shared-components'
import { OptionContainer } from 'domains/aggregate-store-performance/utils/helpers/Dropdown.utils'
import { type FiltersDropdownOption } from 'domains/aggregate-store-performance/components/filters-dropdown/utils/FiltersDropdown.types'

const IconContainer = styled.div({
  alignSelf: 'baseline',
})

const LabelContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  color: colors.GRAYSCALE.X70,
})

const Label = styled.div({
  fontSize: fontSize.X15,
  fontWeight: fontWeight.SEMIBOLD,
})

const SubLabel = styled.div({
  fontSize: fontSize.X12,
  fontWeight: fontWeight.REGULAR,
})

export const Option = (props: OptionProps<FiltersDropdownOption>) => {
  const checkboxId = `group-checkbox-${props.data.value}`
  const selectedValues = props.getValue() as FiltersDropdownOption[]
  const isSelected = selectedValues
    ? selectedValues.some((option: FiltersDropdownOption) => option.value === props.data.value)
    : false

  return (
    <components.Option {...props}>
      <OptionContainer>
        <IconContainer>
          <CheckboxBase checked={isSelected} id={checkboxId} />
        </IconContainer>
        <LabelContainer>
          <Label>{props.data.label}</Label>
          <SubLabel>{props.data.subtitle}</SubLabel>
        </LabelContainer>
      </OptionContainer>
    </components.Option>
  )
}
